import { render } from "./ResultsIndicator.vue?vue&type=template&id=4f158e00&ts=true"
import script from "./ResultsIndicator.vue?vue&type=script&lang=ts"
export * from "./ResultsIndicator.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__